<template>
    <div class="l-body">
        <!-- <div class="back" @click="handleGoBack()">返回</div> -->
        <img class="l-main-img" src="./images/main.png" alt="">
        <img class="l-main-right" src="./images/right.png" alt="">
        <div class="l-main-back">
            <img class="l-back-img" src="./images/back.png" alt="" />
            <div class="l-back-button" @click="handleGoBack()"></div>
        </div>

        <div class="l-name">
            <slot name="mainName"></slot>
        </div>
        <div class="l-content">
            <slot name="mainContent"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "",

    data() {
        return {

        }
    },
    methods: {
        handleGoBack() {
            this.$router.back()
        }
    }
}
</script>
<style lang="stylus" scoped>
@import './index.styl';
</style>